var render, staticRenderFns
import script from "./GTimelineItemPhone.vue?vue&type=script&lang=ts&"
export * from "./GTimelineItemPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830369a",
  null
  
)

export default component.exports